/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getMedicalHistories } from 'app/entities/medical-history/medical-history.reducer';
import { getEntities as getICD10Diagnoses } from 'app/entities/icd-10-diagnosis/icd-10-diagnosis.reducer';
import { createEntity, getEntity, reset, updateEntity } from './diagnosis-history.reducer';

export const DiagnosisHistoryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const medicalHistories = useAppSelector(state => state.medicalHistory.entities);
  const iCD10Diagnoses = useAppSelector(state => state.iCD10Diagnosis.entities);
  const diagnosisHistoryEntity = useAppSelector(state => state.diagnosisHistory.entity);
  const loading = useAppSelector(state => state.diagnosisHistory.loading);
  const updating = useAppSelector(state => state.diagnosisHistory.updating);
  const updateSuccess = useAppSelector(state => state.diagnosisHistory.updateSuccess);

  const handleClose = () => {
    navigate(`/diagnosis-history${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getMedicalHistories({}));
    dispatch(getICD10Diagnoses({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...diagnosisHistoryEntity,
      ...values,
      medicalHistory: medicalHistories.find(it => it.id.toString() === values.medicalHistory?.toString()),
      icdDiagnosis: iCD10Diagnoses.find(it => it.id.toString() === values.icdDiagnosis?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...diagnosisHistoryEntity,
          medicalHistory: diagnosisHistoryEntity?.medicalHistory?.id,
          icdDiagnosis: diagnosisHistoryEntity?.icdDiagnosis?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.diagnosisHistory.home.createOrEditLabel" data-cy="DiagnosisHistoryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.diagnosisHistory.home.createOrEditLabel">Create or edit a DiagnosisHistory</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="diagnosis-history-id"
                  label={translate('tinyMedicRestApp.diagnosisHistory.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.diagnosisHistory.snomedConceptId')}
                id="diagnosis-history-snomedConceptId"
                name="snomedConceptId"
                data-cy="snomedConceptId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagnosisHistory.snomedConceptText')}
                id="diagnosis-history-snomedConceptText"
                name="snomedConceptText"
                data-cy="snomedConceptText"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagnosisHistory.active')}
                id="diagnosis-history-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagnosisHistory.timestampentry')}
                id="diagnosis-history-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagnosisHistory.microSec')}
                id="diagnosis-history-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagnosisHistory.lastupdated')}
                id="diagnosis-history-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagnosisHistory.cursor')}
                id="diagnosis-history-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="diagnosis-history-medicalHistory"
                name="medicalHistory"
                data-cy="medicalHistory"
                label={translate('tinyMedicRestApp.diagnosisHistory.medicalHistory')}
                type="select"
                required
              >
                <option value="" key="0" />
                {medicalHistories
                  ? medicalHistories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="diagnosis-history-icdDiagnosis"
                name="icdDiagnosis"
                data-cy="icdDiagnosis"
                label={translate('tinyMedicRestApp.diagnosisHistory.icdDiagnosis')}
                type="select"
                required
              >
                <option value="" key="0" />
                {iCD10Diagnoses
                  ? iCD10Diagnoses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/diagnosis-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DiagnosisHistoryUpdate;
